// extracted by mini-css-extract-plugin
export default {"cls1":"MejV0P1t1WxSyjDgydMO","cls2":"nNgpRkieYkuwzkSuIz62 MejV0P1t1WxSyjDgydMO","bookingAppRedesign":"lcI15COIvDYfEgFtiOYY"};